import RankingScope from "../entities/RankingScope.js"

class ResultsSlice {
    constructor(scope, resultsForPitchType, resultsForBatterHandedness, resultsForPitcherHandedness, resultsForBatter, resultsForPitcher, resultsForSession) {
        if (!(scope instanceof RankingScope)) {
            throw new TypeError('scope must be an instance inheriting from RankingScope class');
        }

        this.scope = scope;

        if (!(resultsForPitchType instanceof Array)) {
            throw new TypeError('resultsForPitchType must be an array');
        }
        this.resultsForPitchType = resultsForPitchType;

        if (!(resultsForBatterHandedness instanceof Array)) {
            throw new TypeError('resultsForBatterHandedness must be an array');
        }
        this.resultsForBatterHandedness = resultsForBatterHandedness;

        if (!(resultsForPitcherHandedness instanceof Array)) {
            throw new TypeError('resultsForPitcherHandedness must be an array');
        }
        this.resultsForPitcherHandedness = resultsForPitcherHandedness;

        if (!(resultsForBatter instanceof Array)) {
            throw new TypeError('resultsForBatter must be an array');
        }
        this.resultsForBatter = resultsForBatter;

        if (!(resultsForPitcher instanceof Array)) {
            throw new TypeError('resultsForPitcher must be an array');
        }
        this.resultsForPitcher = resultsForPitcher;

        if (!(resultsForSession instanceof Array)) {
            throw new TypeError('resultsForSession must be an array');
        }
        this.resultsForSession = resultsForSession;
    }

    getSmallestSlice() {
        if (this.resultsForPitchType.length) {
            return this.resultsForPitchType;
        }
        if (this.resultsForBatterHandedness.length) {
            return this.resultsForBatterHandedness;
        }
        if (this.resultsForPitcherHandedness.length) {
            return this.resultsForPitcherHandedness;
        }
        if (this.resultsForBatter.length) {
            return this.resultsForBatter;
        }
        if (this.resultsForPitcher.length) {
            return this.resultsForPitcher;
        }
        return this.resultsForSession;
    }

    getBiggestSlice() {
        if (this.resultsForSession.length) {
            return this.resultsForSession;
        }
        if (this.resultsForPitcher.length) {
            return this.resultsForPitcher;
        }
        if (this.resultsForBatter.length) {
            return this.resultsForBatter;
        }
        if (this.resultsForPitcherHandedness.length) {
            return this.resultsForPitcherHandedness;
        }
        if (this.resultsForBatterHandedness.length) {
            return this.resultsForBatterHandedness;
        }

        return this.resultsForPitchType;
    }

    /**
     * checks whether scope has slice other than just all session results
     */
    hasSubSlice() {
        return this.resultsForSession !== this.getSmallestSlice();
    }
}

export default ResultsSlice;